var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNotiPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6713_75282)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6713_75282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5491 13.6276L16.9897 10.6237L17.9612 11.5952C18.2663 11.9003 18.761 11.9003 19.0661 11.5952L20.1709 10.4904C20.476 10.1853 20.476 9.69063 20.1709 9.38553L13.9101 3.12469C13.605 2.81959 13.1103 2.81959 12.8052 3.12469L11.7004 4.22954C11.3953 4.53465 11.3953 5.0293 11.7004 5.3344L12.6719 6.30591L9.66803 8.74653C8.03238 8.14913 6.23916 8.21763 5.07126 9.38553C4.76616 9.69063 4.76616 10.1853 5.07126 10.4904L8.20168 13.6208L5.80766 16.0148C5.77908 16.0434 5.75753 16.0783 5.74476 16.1166L5.19233 17.7739C5.12463 17.977 5.31826 18.1711 5.52174 18.1033L7.17902 17.5509C7.21737 17.5381 7.25223 17.5166 7.28083 17.488L9.67484 15.094L12.8053 18.2244C13.1104 18.5295 13.605 18.5295 13.9101 18.2244C15.0882 17.0462 15.1401 15.2458 14.5491 13.6276V13.6276Z",
    fill: "#00263E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6713_75282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6713_75282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.5,
    height: 16.6667,
    fill: "white",
    transform: "translate(12.6211 1.83569) rotate(45)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotiPin);
export default __webpack_public_path__ + "static/media/iconNotiPin.9e647ad30cdf65989028434c66ed825a.svg";
export { ForwardRef as ReactComponent };